export const getStatusColor = (status_code) => {
  if (status_code === null) {
    return 'info';
  }
  return status_code >= 200 && status_code < 300 ? 'success' : 'error';
};

/**
 * Get the color for event status chip
 * @param {string} status - Event status: 'pending' | 'queued' | 'processing' | 'succeeded' | 'failed' | 'paused'
 * @returns {string} Color for the status chip
 */
export const getEventStatusColor = (status) => {
  if (!status) {
    return undefined;
  }

  switch (status) {
    case 'succeeded':
      return 'success';
    case 'failed':
      return 'error';
    case 'pending':
      return 'info';
    case 'queued':
      return 'info';
    case 'processing':
      return 'info';
    case 'paused':
      return 'warning';
    default:
      return undefined;
  }
};
